<template>
  <div>
    <!--Flower, Jessikah & Ben, Let us know text section header-->
    <v-container
      id="main-header"
      fluid
      class="description"
      fill-height
      v-if="!show"
    >
      <v-row id="main-flower-header" justify="center">
        <v-col cols="12" md="7" xs="12" sm="10" lg="5" class="text-center">
          <v-img id="main-flower" src="../../images/Jessikahandben.png">
          </v-img>
        </v-col>
      </v-row>
      <v-row id="let-us-know-text-section" justify="center">
        <v-col cols="10" md="7" xs="12" sm="10" lg="5" class="text-center">
          <span class="details">Let us know if you can make it</span>
          <br />
          <span class="details">by <b>Wednesday 5th March</b></span>
        </v-col>
      </v-row>

      <!--Enter RSVP + text box input field-->
      <v-row id="enter-rsvp-section" justify="center" class="text-center">
        <v-col md="8" sm="10" xs="12">
          <v-card :elevation="0" :loading="loading">
            <v-card-text>
              <div class="details">Enter your RSVP ID below:</div>
            </v-card-text>
            <p>
              <v-row justify="center">
                <v-col md="4" sm="8" cols="6">
                  <v-text-field
                    v-model="rsvpID"
                    label="RSVP ID"
                    solo
                    :loading="textBoxLoading"
                  ></v-text-field>
                </v-col>
              </v-row>
            </p>
            <v-alert :value="showRsvpIdNotFound" type="warning" color="#f4d142"
              >Please enter a valid RSVP ID</v-alert
            >
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-container
      id="main-wedding-info"
      fluid
      class="description"
      fill-height
      v-if="show"
    >
      <v-row justify="center" class="text-center">
        <v-col cols="10" md="7" xs="12" sm="10" lg="5">
          <!-- <v-alert :value="showAlreadyCompleteMessage" type="success" color="green">
            <div class="details">
              {{ alreadyCompleteMessage }}
            </div>
          </v-alert> -->

          <!-- <v-row>
            <v-col class="pa-0">
              <div class="details">
                <p>Please see below details about the day...</p>
              </div>
            </v-col>
          </v-row>
 -->

          <v-row>
            <v-col>
              <v-divider></v-divider>
              <br />
              <p class="h2">Our Venue</p>
              <!-- <p>Please arrive anytime from 13:30</p> -->
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <!-- <div class="phone"> -->
              <img id="old-mill" src="../../images/old-mill.png" />
              <span>The Old Mill</span>
              <p>
                <span>
                  <p class="details pa-0 ma-0">Aldermaston</p>
                  <p class="details pa-0 ma-0">Basingstoke Rd</p>
                  <p class="details pa-0 ma-0">Reading</p>
                  <p class="details pa-0 ma-0">RG7 4LB</p>
                </span>
              </p>
              <v-row>
                <v-col>
                  <v-responsive aspect-ratio="16/9">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2489.593343319149!2d-1.151597!3d51.3921516!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4876a1cba357145f%3A0xe7cf96a3e1cf599d!2sThe%20Old%20Mill!5e0!3m2!1sen!2suk!4v1734631357210!5m2!1sen!2suk"
                      frameborder="0"
                      style="
                        align: center;
                        width: 85%;
                        max-width: 500px;
                        min-width: 300px;
                        height: 200px;
                      "
                      allowfullscreen=""
                      loading="lazy"
                      referrerpolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </v-responsive>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <p class="h3">Accommodation & Transport</p>
              <p class="details">
                There is no accomodation on site, however there are lots of
                accommodation options available in the local area should you
                wish to stay, including the following that you may wish to
                consider:
              </p>
              <v-row>
                <v-col justify="center">
                  <div class="details">
                    <b> The Hind Head - Aldermaston </b>
                  </div>
                  <div class="details">
                    <a
                      href="https://maps.app.goo.gl/KMPCLuf6L4JL6Qrr5"
                      target="_blank"
                      >Google Maps</a
                    >
                  </div>
                  <p></p>
                  <div class="details">
                    <b> Holiday Inn - Reading, Bath Rd. </b>
                  </div>
                  <div class="details">
                    <a
                      href="https://maps.app.goo.gl/dL4wgT8DG2eaYP8L8"
                      target="_blank"
                      >Google Maps</a
                    >
                  </div>
                  <p></p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <p class="h3">Local Taxi Companies</p>
              <p class="details">
                Here are some local taxi companies that you may wish to use:
              </p>
              <b class="details"
                >Compass Executive Cars:
                <a class="details" href="tel:01189321321"> 0118 970 2233</a>
              </b>
              <div></div>
              <b class="details"
                >Theale Taxis:
                <a class="details" href="tel:01189321321"> 0118 930 2345</a>
              </b>
            </v-col>
          </v-row>

          <v-row justify="center">
            <v-col>
              <v-divider></v-divider>
              <v-img
                id="timeline"
                src="../../images/timeline-narrow.jpeg"
              ></v-img>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-divider></v-divider>
              <br />
              <p class="h2">Dress Code</p>
              <div class="details">Dress to impress!</div>
              <div class="details">NO black.</div>
              <div class="details"><b>Bright colours encouraged!</b></div>
              <br />
            </v-col>
          </v-row>

          <!-- <v-row>
                    <v-col>
                      <v-row>
                        <v-col>
                          <p class="h3">Local Taxi Companies</p>
                        </v-col>
                      </v-row>
                      <v-row justify="center" align="center">
                        <v-col md="10">
                          <div class="details">
                            Here are some local taxi companies that you may wish
                            to use:
                          </div>
                          <div class="details">Loddon Taxis Twyford</div>
                          <div class="details">
                            <a href="tel:01189321321">0118 932 1321</a>
                          </div>
                          <p />
                          <div class="details">Triple A Cars</div>
                          <div class="details">
                            <a href="tel:01189504030">0118 950 4030</a>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row> -->

          <v-row>
            <v-col>
              <v-divider></v-divider>
            </v-col>
          </v-row>
          <v-row>
            <v-col style="padding-top: 40px">
              <p class="h2">RSVP</p>
            </v-col>
          </v-row>

          <div
            v-for="(person, index) in rsvpList.people"
            :key="index"
            class="details"
          >
            <v-row align="center" justify="center">
              <v-col>
                Is
                <strong>{{ person.name }}</strong> attending?
              </v-col>
              <v-col>
                <v-switch
                  v-model="person.attending"
                  :label="boolToString(person.attending)"
                ></v-switch>
              </v-col>
            </v-row>
            <!-- Dietary and Allergens -->
            <v-row
              v-if="person.attending == true"
              align="center"
              justify="center"
            >
              <v-col xs8>
                <strong>Dietary and Allergen</strong>
                <p class="details">{{ dietaryLabel(person.name) }}</p>
              </v-col>
              <v-col xs2>
                <v-text-field
                  v-model="person.dietary"
                  solo
                  placeholder="Dietary and Allergen"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>

          <div>
            <br />
            <v-alert :value="showErrorMessage" type="error" color="red">{{
              errorMessage
            }}</v-alert>
            <v-alert :value="showSuccessMessage" type="success" color="green">{{
              successMessage
            }}</v-alert>
            <v-btn
              rounded
              color="primary"
              large
              :loading="pendingSubmit"
              :disabled="disableRSVPbutton"
              @click="submitRSVP()"
              >Complete RSVP</v-btn
            >
            <br />
            <br />
            <template>
              <v-dialog
                v-model="progressBarVisable"
                hide-overlay
                persistent
                width="300"
              >
                <v-card color="primary" dark>
                  <v-card-text>
                    {{ progressBarText }}
                    <v-progress-linear
                      indeterminate
                      color="white"
                      class="mb-0"
                    ></v-progress-linear>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </template>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
const axios = require("axios");
export default {
  data: () => ({
    rsvpID: "",
    loading: false,
    show: false,
    hotelRequired: false,
    pendingSubmit: false,
    errorMessage: "",
    showErrorMessage: false,
    successMessage: "",
    showSuccessMessage: false,
    showAlreadyCompleteMessage: false,
    textBoxLoading: false,
    showRsvpIdNotFound: false,
    disableRSVPbutton: false,
    progressBarVisable: false,
    progressBarText: "Please wait...",
    radioGroupStarter: null,
    radioGroupMains: null,
    radioGroupPortionSize: null,
    alreadyCompleteMessage:
      "You have already completed this RSVP.\r\nFeel free to alter and re-submit any changes.",
    rsvpList: {},
  }),
  mounted() {
    // this.$refs.videoRef.play();
  },
  methods: {
    next() {
      this.onboarding =
        this.onboarding + 1 === this.length ? 0 : this.onboarding + 1;
    },
    boolToString(bool) {
      if (bool) {
        return "Yes";
      } else {
        return "No";
      }
    },
    dietaryLabel(name) {
      return (
        "Are there any special dietary or allergy requirements for " +
        name +
        "?"
      );
    },
    submitRSVP() {
      // console.log("Submit: ", this.rsvpList);
      this.disableRSVPbutton = true;
      this.progressBarVisable = true;
      const headers = {
        "Access-Control-Allow-Headers": "*",
      };
      console.log(this.rsvpList);
      const instance = axios.create({
        baseURL: "https://api.thetaylorswedding.co.uk",
      });
      instance.defaults.timeout = 20000;
      instance
        .post("/", this.rsvpList)
        .then((response) => {
          this.successMessage = "RSVP successfully submitted. Thank you!";
          this.showSuccessMessage = true;
          setTimeout(() => (this.disableRSVPbutton = false), 5000);
          this.progressBarVisable = false;
        })
        .catch((errorMsg) => {
          this.showErrorMessage = true;
          this.errorMessage = errorMsg;
          console.log(errorMsg);
          this.disableRSVPbutton = false;
          this.progressBarVisable = false;
        });
    },
  },
  watch: {
    rsvpID: function (input) {
      if (input.length >= 4) {
        this.textBoxLoading = true;
        axios
          .get("https://api.thetaylorswedding.co.uk/?rsvp_id=" + this.rsvpID)
          .then((response) => {
            this.show = true;
            this.rsvpList = response.data;
            // console.log(response.data);
            this.showRsvpIdNotFound = false;
            this.textBoxLoading = false;
            this.showAlreadyCompleteMessage = false;
            if (response.data.rsvp_complete) {
              this.showAlreadyCompleteMessage = true;
            }
            // Remove focus
            document.activeElement.blur();
            // Scroll down the page
            // const elementSelector = "#auto-scroll-element";
            // const element = document.querySelector(elementSelector);
            // this.$vuetify.goTo(element, {
            //   duration: 500,
            //   offset: 0,
            //   easing: "easeInOutCubic",
            // });
          })
          .catch((errorMsg) => {
            console.log(errorMsg);
            this.showRsvpIdNotFound = true;
            this.show = false;
            this.showSuccessMessage = false;
            this.textBoxLoading = false;
          });
      } else {
        this.show = false;
        this.showSuccessMessage = false;
        this.showRsvpIdNotFound = false;
        this.textBoxLoading = false;
      }
    },
    rsvpList: function (val) {
      console.log("Changed: ", val);
    },
    showErrorMessage(val) {
      if (!val) return;

      setTimeout(() => (this.showErrorMessage = false), 5000);
    },
  },
};
</script>

<style>
#main-flower {
  padding-bottom: -10em;
  margin-bottom: -50px;
  /* position: absolute; */
  /* background-position: top; */
}

.details {
  margin-top: -800px;
  /* margin: 1vmin; */
  /* font-size: 18px; */
  font-size: 1rem;
  font-family: "Questa Grande";
}

.h1 {
  font-family: "Lambresia";
  font-size: 40px;
  color: #0f433b;
}

.h2 {
  font-family: "Bacalisties";
  font-size: 3rem;
  color: #0f433b;
}

.h3 {
  color: #0f433b;
  font-size: 1.3rem;
}

.heading-small {
  font-family: "Lambresia";
  font-size: 20px;
  color: #0f433b;
}

.description {
  font-family: "Questa Grande";
  font-size: 20px;
  /* color: #609e62; */
}

.truncate {
  text-align: start;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.description-large {
  font-family: "Questa Grande";
  font-size: 40px;
  /* color: #609e62; */
}

.details {
  margin: auto;
  /* font-size: 18px; */
  font-size: 1rem;
  font-family: "Questa Grande";
}

.v-radio {
  margin: 1vmin;
  font-size: 1rem;
}

.v-text-field {
  margin: 1vmin;
  font-size: 1rem;
}

.details-no-padding {
  margin: 1vmin;
  font-size: 1rem;
  padding: 0px;
}

.details-heading {
  color: #0f433b;
  font-size: 1.1rem;
}

.word-wrap {
  /* Warning: Needed for oldIE support, but words are broken up letter-by-letter */
  -ms-word-break: break-all;
  word-break: break-all;
  /* Non standard for webkit */
  word-break: break-word;

  -webkit-hyphens: auto;
  -moz-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
}

.custom-timeline .v-timeline-item__line {
  background-color: red;
}

.custom-timeline .v-timeline-item__dot {
  border-color: red;
}

#old-mill {
  width: 3.5em;
  margin-bottom: -1.5em;
  margin-left: -1em;
}

#timeline {
  max-width: 385px;
  justify-self: center;
}

#let-us-know-text-section {
  margin-top: 1.5em;
}
</style>
